import JQuery from 'jquery'

let $ = JQuery

var PSYAPI = PSYAPI || new function () {
    var
        /**
         * The base URL to access the swiss-skills REST API.
         * https://staging.swiss-skills.ch
         * @type String
         */
        BASE_URL = 'https://missionfuture.swiss-skills.ch/mfp/admin/rest/',
        /**
         * The Mail Template ID. This is the template ID for sending the
         * result email. Array index for specific language is:<br>
         * 0=german<br>
         * 1=english<br>
         * 2=french<br>
         * 3=italian<br>
         *
         * @type Number
         */
        MAIL_TEMPLATE_ID = ['1', 'EN', 'FR', 'IT'],
        /**
         * The SMS Template ID. This is the template ID for sending the
         * result SMS. Array index for specific language is:<br>
         * 0=german<br>
         * 1=english<br>
         * 2=french<br>
         * 3=italian<br>
         *
         * @type Number
         */
        SMS_TEMPLATE_ID = ['1', 'EN', 'FR', 'IT'],
        /**
         * Array laguage index for german.
         * @type Number
         */
        LANG_DE = 0,
        /**
         * Array language index for english.
         * @type Number
         */
        LANG_EN = 1,
        /**
         * Array language index for french.
         * @type Number
         */
        LANG_FR = 2,
        /**
         *
         * @type NumberArray language index for italian.
         */
        LANG_IT = 3,
        /**
         * Your API Key to access the swiss-skills REST API.
         * @type String
         */
        APIKEY = '83d735f2bf3d392d556d8a2eafed1fe0',
        /**
         * The application secret key.
         * @type String
         */
        /*
        SKEY = (function () {
            var secretKey = secretKey || null;
            $.ajax({
                method: 'GET',
                //url: 'https://service.swiss-skills.ch/admin/sk/kstore.json',
                //url: 'http://localhost/swissskills_final/kstore.json',
                url: 'kstore.json',
                dataType: 'json',
                success: function (data) {
                    SKEY = data.key;
                }
            });
        })(),
        */
        /**
         * Create a signature for authenticate at the REST API.
         *
         * @param {String} time the actual UTC time string (Date.toUTCString).
         * @returns {String} the signature.
         */
        /*
        sign = function (time) {
            var md = new jsSHA('SHA-256', 'TEXT'),
                    secret = SKEY;
            md.setHMACKey(secret, 'HEX');
            md.update(APIKEY);
            md.update(time.trim());
            return md.getHMAC('HEX');
        },*/
        /**
         * Generalized GET API call.
         *
         * @param {String} url the url to call (without the BASE_URL).
         * @param {Any} id the object id.
         * @param {function} callback a callback funtion. The following
         * parameters will be passed to this function: <pre>
         *  function(int status, object data)
         * </pre>
         * @returns {jqXHR} a jQuery jqXHR object.
         */
        get = function (url, id, callback) {
            //                var now = new Date().toUTCString();
            return $.ajax({
                method: 'GET',
                url: BASE_URL + url + (id === null ? '' : '/' + id),
                dataType: 'json',
                //                    headers: {
                //                        apikey: APIKEY,
                //                        time: now,
                //                        signature: sign(now)
                //                    },
                success: function (data, statusText, xhr) {
                    if (callback) {
                        callback(xhr.status, data);
                    }
                },
                error: function (xhr) {
                    if (callback) {
                        callback(xhr.status);
                    }
                }
            });
        },
        /**
         * Generalized POST API call.
         *
         * @param {String} url the url to call (without the BASE_URL).
         * @param {Object} data the object to send.
         * @param {function} callback a callback funtion. The following
         * parameters will be passed to this function: <pre>
         *  function(int status, object data)
         * </pre>
         * @returns {jqXHR} a jQuery jqXHR object.
         */
        post = function (url, data, callback) {
            //                var now = new Date().toUTCString();
            return $.ajax({
                method: 'POST',
                url: BASE_URL + url,
                data: JSON.stringify(data),
                contentType: "application/json",
                dataType: 'json',
                //                    headers: {
                //                        apikey: APIKEY,
                //                        time: now,
                //                        signature: sign(now)
                //                    },
                success: function (data, statusText, xhr) {
                    if (callback) {
                        callback(xhr.status, data);
                    }
                },
                error: function (xhr) {
                    if (callback) {
                        callback(xhr.status);
                    }
                }
            });
        };
    return {
        /**
         * The TAN functionality object. All functions around the TAN access
         * are grouped here.
         *
         * validateTan()
         * invalidateTan()
         */
        tan: {
            /**
             * Check if a TAN is valid (state==active) or not (state==false).
             *
             * @param {String} tan the TAN string.
             * @param {Numeric} projectId the project ID.
             * @param {function} callback a callback function with a parameter "isvalid".
             * The parameter can be true (if the TAN is valid) or false (if not).
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            validateTan: function (tan, projectId, callback) {
                if (tan && projectId && callback) {
                    //                    var now = new Date().toUTCString();
                    return $.ajax({
                        method: 'GET',
                        url: BASE_URL + 'tan/validate/' + tan + '/' + projectId,
                        //                        headers: {
                        //                            apikey: APIKEY,
                        //                            time: now,
                        //                            signature: sign(now)
                        //                        },
                        success: function () {
                            callback(true);
                        },
                        error: function () {
                            callback(false);
                        }
                    });
                }
            },
            /**
             * Invalidate a TAN. This set the TAN state to false.
             *
             * @param {String} tan the TAN string.
             * @param {Numeric} projectId the project ID.
             * @param {function} callback a callback function with a parameter "success".
             * The parameter can be true (if the TAN is successfully invalidated) or false (if not).
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            invalidateTan: function (tan, projectId, callback) {
                if (tan && projectId && callback) {
                    //                    var now = new Date().toUTCString();
                    return $.ajax({
                        method: 'GET',
                        url: BASE_URL + 'tan/invalidate/' + tan + '/' + projectId,
                        //                        headers: {
                        //                            apikey: APIKEY,
                        //                            time: now,
                        //                            signature: sign(now)
                        //                        },
                        success: function () {
                            callback(true);
                        },
                        error: function () {
                            callback(false);
                        }
                    });
                }
            }
        },
        /**
         * The project functionality object. All functions around the project
         * are grouped here.
         *
         * read()
         * forURL()
         */
        project: {
            /**
             * Read a specified project from the database.
             * @param {Numeric} id the project id.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            read: function (id, callback) {
                return get('project/read', id, callback);
            },
            /**
             * Get a project from a given URL.
             * @param {String} url the url.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            forURL: function (url, callback) {
                var now = new Date().toUTCString();
                return $.ajax({
                    method: 'GET',
                    url: BASE_URL + 'project?url=' + url,
                    headers: {
                        apikey: APIKEY,
                        time: now
                        //signature: sign(now)
                    },
                    success: function (data, statusText, xhr) {
                        if (callback) {
                            callback(xhr.status, data);
                        }
                    },
                    error: function (xhr) {
                        if (callback) {
                            callback(xhr.status);
                        }
                    }
                });
            }
        },
        /**
         * The participant functionality object. All functions around the participant
         * are grouped here.
         *
         * create()
         * update()
         * updateImage()
         */
        participant: {
            /**
             * Create a new participant.
             *
             * @param {object} participant a new participant object.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            create: function (participant, callback) {
                return post('participant/create', participant, callback);
            },
            /**
             * Read an existing participant from the database.
             *
             * @param {Numeric} id the participant id.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            read: function (id, callback) {
                return get('participant/read', id, callback);
            },
            /**
             * Update an existing participant.
             *
             * @param {object} participant the participant to update.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            update: function (participant, callback) {
                return post('participant/update', participant, callback);
            },
            /**
             * Update an existing participant with a user image.
             *
             * @param {Numeric} id the participant id.
             * @param {file} file the image file from a HTTP Input object.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            updateImage: function (id, file, callback) {
                var formData = new FormData(); //, now = new Date().toUTCString();
                formData.append('pid', id);
                formData.append('file', file);
                return $.ajax({
                    method: 'POST',
                    url: BASE_URL + 'participant/update/image',
                    data: formData,
                    contentType: false,
                    processData: false,
                    //                    headers: {
                    //                        apikey: APIKEY,
                    //                        time: now,
                    //                        signature: sign(now)
                    //                    },
                    success: function (data, statusText, xhr) {
                        if (callback) {
                            callback(xhr.status, data);
                        }
                    },
                    error: function (xhr) {
                        if (callback) {
                            callback(xhr.status);
                        }
                    }
                });
            },
            /**
             * Check if the given data is empty.
             *
             * @param {String} data the data to check
             * @returns {Boolean} true if the data is empty, otherwise false.
             */
            isEmpty: function (data) {
                if (data) {
                    return (!$.trim(data.html()));
                } else {
                    return true;
                }
            },
            /**
             * Validate a name (firstname, lastname).
             *
             * @param {String} name the name to check.
             * @returns {Boolean} true if the name is a valid string,
             * otherwise false.
             */
            /*
            validateName: function (name) {
                if (isEmpty(name)) {
                    return false;
                } else {
                    return $.type(name) === 'string';
                }
            },
            */
            /**
             * Validate an email address.
             *
             * @param {type} email the email to check.
             * @returns {Boolean} true if the passed string is an email address,
             * otherwise false.
             */
            validateEmail: function (email) {
                return /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/.test(email);
            },
            /**
             * Validate an age.
             *
             * @param {Numeric} age the age to validate.
             * @returns {Boolean} true if the passed age is numeric and it's range
             * is between 10 and 100, otherwise false.
             */
            validateAge: function (age) {
                if ($.isNumeric(age)) {
                    return (age >= 10 && age <= 100);
                } else {
                    return false;
                }
            },
            /**
             *  Validate a (birth)date. This also incude a leap year check.
             *
             * @param {String} dob the date of birth to check (dd.mm.yyyy).
             * @returns {Boolean} true if the passed date is a date, otherwise false.
             */
            validateDoB: function (dob) {
                var regEx = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-./])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
                return regEx.test(dob);
            },
            /**
             * Validate a swiss postcode.
             *
             * @param {Number} postcode the postcode to validate.
             * @param {function} callback a callback function passing the following
             * parameter: validated: true if the passed postcode is a swiss postcode,
             * otherwise false.
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            validatePostcode: function (postcode, callback) {
                return get('postcode/verify', postcode, function (status) {
                    if (status === 200) {
                        callback(true);
                    } else {
                        callback(false);
                    }
                });
            }
        },
        /**
         * The postcode functionality object. All functions around the postcode
         * are grouped here.
         *
         * suggest()
         */
        postcode: {
            /**
             * Return a list of valid swiss postcodes from the given fragment.
             *
             * @param {Numeric} fragment a postcode fragment.
             * @param {type} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            suggest: function (fragment, callback) {
                return get('postcode/suggest', fragment, callback);
            },
            /**
             * Validate a swiss postcode.
             *
             * @param {Number} postcode the postcode to validate.
             * @param {function} callback  a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            validate: function (postcode) {
                return new Promise((resolve, reject) => {
                    get('postcode/verify', postcode, (status => {
                        if (status === 200 || status === 204) {
                            resolve(status);
                        } else {
                            reject(status);
                        }
                    }));
                });
            }
        },
        /**
         * The result functionality object. All functions around the result
         * are grouped here.
         *
         * sendMail()
         * sendSMS()
         * print()
         */
        result: {
            /**
             * Send the PST result via E-Mail to the participant.
             *
             * @param {Object} participant the participant.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            sendMail: function (participant, callback) {
                var lang;
                switch (participant.language.id) {
                    case 'de':
                        lang = LANG_DE;
                        break;
                    case 'fr':
                        lang = LANG_FR;
                        break;
                    case 'it':
                        lang = LANG_IT;
                        break;
                    default:
                        lang = LANG_EN;
                }
                return get('communication/send/mail', participant.id + '/' + MAIL_TEMPLATE_ID[lang], callback);
            },
            /**
             * Send the PST result via SMS to the participant.
             *
             * @param {Object} participant the participant.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            sendSMS: function (participant, callback) {
                var lang;
                switch (participant.language.id) {
                    case 'de':
                        lang = LANG_DE;
                        break;
                    case 'fr':
                        lang = LANG_FR;
                        break;
                    case 'it':
                        lang = LANG_IT;
                        break;
                    default:
                        lang = LANG_EN;
                }
                return get('communication/send/sms', participant.id + '/' + SMS_TEMPLATE_ID[lang], callback);
            },
            /**
             * Send the PST result to the printer quque.
             *
             * @param {Numeric} id the participant id.
             * @param {function} callback a callback function. The following
             * parameters will be passed to this function: <pre>
             *  function(int status, object data)
             * </pre>
             * @returns {jqXHR} a jQuery jqXHR object.
             */
            print: function (id, callback) {
                return get('result/print', id, callback);
            },
            /**
             * Send a flag to mark participant as not printed.
             * 
             * @param {type} id The participant id.
             * @param {type} callback A callback function.
             * @returns {jqXHR} a jQuery jqSHR object.
             */
            notPrinted: function (id, callback) {
                return get('result/setprinted', id, callback);
            }
        }
    };
};

export default PSYAPI;